import { Component, OnInit } from '@angular/core';
import { StateCustomPanelVehicleService } from 'src/app/vehicles/components/content-panel-vehicles/service/state-custom-panel-vehicle.service';
import { MapService } from 'src/app/vehicles/services/map.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { ConfigKeys } from 'src/app/shared/models/configuration';
import {
  CardConfig,
  LocalStorageData,
  VehicleData,
} from './models/user-card.model';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';

@Component({
  selector: 'app-user-card-vehicle',
  templateUrl: './user-card-vehicle.component.html',
  styleUrls: ['./user-card-vehicle.component.scss'],
})
export class UserCardVehicleComponent implements OnInit {
  activeTab: string = 'nombre';

  tabs = [
    { id: 'placa', label: 'Placa' },
    { id: 'codigo', label: 'Código interno' },
    { id: 'nombre', label: 'Nombre' },
  ];

  // Datos estáticos de prueba
  vehicleData: VehicleData = {
    name: '(C001) ABC-123',
    plate: 'ABC-123',
    internalCode: 'C001',
    imei: '876876123762345',
    sim: '8954012345678901234',
    date: '12/12/2023 a las 14:30:25',
    location: 'Zona Central, Lima',
    speed: 45,
    voltage: 12.7,
    fuel: 15,
    ignition: true,
    elapsedTime: '02:15:30',
    satellites: 8,
    temperatureBLE: 22,
    temperatureEYE: 24,
    humidityBLE: 55,
    humidityEYE: 60,
    driverName: 'Juan Pérez',
    transmissionStatus: 1,
    // Ruta adaptada para assets Angular (debe estar en src/assets/images/vehicle/auto.svg)
  };

  // Configuración por defecto
  config: CardConfig = {
    showIMEI: false,
    showSIM: false,
    showColorStatus: true,
    showIgnitionStatus: false,
    showSpeed: true,
    showBatteryVoltage: false,
    showFuel: false,
    showElapsedTime: true,
    showSatellites: false,
    showTemperatureBLE: false,
    showTemperatureEYE: false,
    showHumidityBLE: false,
    showHumidityEYE: false,
    showVehicleIcon: true,
    showDriverName: false,
    // showActionButtons: true,
    showHistoryButton: true,
    showCommandButton: false,
    showDriverButton: false,
    showNameButton: false,
    showFollowButton: true,
    showVisualizationButton: true,
  };

  messageResponse: string = '';
  animateCard: boolean = false;

  constructor(
    private servicePanel: StateCustomPanelVehicleService,
    private mapService: MapService,
    private vehicleService: VehicleService,
    private localStorageService : LocalStorageService
  ) {}

  ngOnInit(): void {
    this.loadConfiguration();
  }

  getDisplayValue(): string {
    switch (this.activeTab) {
      case 'placa':
        return this.vehicleData.plate;
      case 'codigo':
        return this.vehicleData.internalCode;
      case 'nombre':
        return this.vehicleData.name;
      default:
        return this.vehicleData.name;
    }
  }

  getTransmissionClass(): string {
    switch (this.vehicleData.transmissionStatus) {
      case 1:
        return 'status-online';
      case 2:
        return 'status-offline';
      case 3:
        return 'status-warning';
      default:
        return 'status-unknown';
    }
  }

  saveConfiguration(): void {
    localStorage.setItem(
      ConfigKeys.VEHICLE_CARD,
      JSON.stringify({ ...this.config, activeTab: this.activeTab })
    );
    // Aquí puedes agregar lógica adicional para notificar al usuario
    console.log('(CONFIG) Configuración guardada:', this.config);
    this.saveConfigurationInService();
    this.saveTabConfiguration();
    this.messageResponse = 'Configuración guardada exitosamente.';
    this.resetMessage();
    this.triggerCardAnimation();
  }

  loadConfiguration(): void {
    const savedConfig = localStorage.getItem(ConfigKeys.VEHICLE_CARD);
    if (savedConfig) {
      const parsedConfig: LocalStorageData = JSON.parse(savedConfig);
      this.config = { ...this.config, ...parsedConfig };
      this.activeTab = parsedConfig.activeTab;
    }
  }

  resetConfiguration(): void {
    this.config = {
      showIMEI: false,
      showSIM: false,
      showColorStatus: true,
      showIgnitionStatus: false,
      showSpeed: true,
      showBatteryVoltage: false,
      showFuel: false,
      showElapsedTime: false,
      showSatellites: false,
      showTemperatureBLE: false,
      showTemperatureEYE: false,
      showHumidityBLE: false,
      showHumidityEYE: false,
      showVehicleIcon: true,
      showDriverName: false,
      // showActionButtons: true,
      showHistoryButton: true,
      showCommandButton: false,
      showDriverButton: false,
      showNameButton: false,
      showFollowButton: true,
      showVisualizationButton: true,
    };
    this.activeTab = 'nombre';
    this.saveConfiguration();
    this.messageResponse =
      'Configuración restablecida a los valores por defecto.';
    this.resetMessage();
    this.triggerCardAnimation();
  }

  triggerCardAnimation(): void {
    this.animateCard = true;
    setTimeout(() => {
      this.animateCard = false;
    }, 350);
  }

  private saveConfigurationInService(): void {
    this.servicePanel.setShowImei(this.config.showIMEI);
    this.servicePanel.setShowNumSim(this.config.showSIM);
    this.servicePanel.setShowColorStatus(
      this.config.showColorStatus
    );
    this.servicePanel.setShowIgnitionStatus(this.config.showIgnitionStatus);
    this.servicePanel.setShowSpeed(this.config.showSpeed);
    this.servicePanel.setShowBatteryVoltage(this.config.showBatteryVoltage);
    this.servicePanel.setShowAmountOfFuel(this.config.showFuel);
    this.servicePanel.setShowTimeElapsed(this.config.showElapsedTime);
    this.servicePanel.setShowSatelliteCount(this.config.showSatellites);
    this.servicePanel.setShowTemperatureBle(this.config.showTemperatureBLE);
    this.servicePanel.setShowTemperatureEye(this.config.showTemperatureEYE);
    this.servicePanel.setShowHumidityBle(this.config.showHumidityBLE);
    this.servicePanel.setShowHumidityEye(this.config.showHumidityEYE);
    this.servicePanel.setShowIconVehicle(this.config.showVehicleIcon);
    this.servicePanel.setShowNameDriver(this.config.showDriverName);
    this.servicePanel.setShowHistoryButton(this.config.showHistoryButton);
    this.servicePanel.setShowCommandButton(this.config.showCommandButton);
    this.servicePanel.setShowDriverButton(this.config.showDriverButton);
    this.servicePanel.setShowNameButton(this.config.showNameButton);
    this.servicePanel.setShowFollowUnitButton(this.config.showFollowButton);
    this.servicePanel.setShowEyeButton(this.config.showVisualizationButton);
    this.servicePanel.activeTabConf = this.activeTab;
  }

  private saveTabConfiguration() {
    switch (this.activeTab) {
      case 'nombre': {
        this.servicePanel.setShowNameItemButton(true);
        this.mapService.changeNameVehicles('Nombre');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.name_old;
            return vehicle;
          }
        );
        break;
      }
      case 'codigo': {
        this.servicePanel.setShowInternalCodeItemButton(true);
        this.mapService.changeNameVehicles('cod_interno');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.cod_interno!;
            return vehicle;
          }
        );
        break;
      }
      case 'placa': {
        this.servicePanel.setShowNamePlateItemButton(true);
        this.mapService.changeNameVehicles('num_plate');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.plate_number!;
            return vehicle;
          }
        );
        break;
      }
      default: {
        console.log('Revisar los value que brindaste en options');
      }
    }
  }

  private resetMessage() {
    setTimeout(() => {
      this.messageResponse = '';
    }, 3000);
  }
}
